import React from 'react';
import { Link } from 'found';
import styles from './Fab.scss';
export default class Fab extends React.Component {

  render() {
    return (
      <Link to='/events/new' style={{ position: 'fixed', right: '20px', bottom: '20px', zIndex: 10 }}>
        <button className={['ui circular icon secondary button huge', styles.fab].join(' ')}>
          <i className='plus icon'></i>
        </button>
      </Link>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Elements/Fab/Fab.js